import { Sector } from '@/domain/impact/impact.entity';
import {
  Category,
  ImpactCo2Answer,
  MealType,
  MealTypeValues,
  ValuesCateringMeal,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { ImportedRow } from '../convert-excel-to-impact-answers';
import { buildBaseAnswer } from './common/build-base-answer';
import {
  filterRowsByCategory,
  filterRowsBySectors,
} from './common/filter-rows-by-category';
import { ImportMappingError } from './common/import-mapping.error';

const CATEGORY: Category = 'CATERING_MEAL';
const SECTORS: Sector[] = ['TEAM', 'ARTISTS', 'PUBLIC'];

export function mapToCateringMealAnswers(
  rows: ImportedRow[],
): ImpactCo2Answer<ValuesCateringMeal>[] {
  return rows
    .filter(filterRowsByCategory(CATEGORY))
    .filter(filterRowsBySectors(SECTORS))
    .map((row) => buildAnswer(row));
}

function buildAnswer(row: ImportedRow) {
  const mealType = mapToMealType(row);
  const mealCount = mapToMealCount(row);
  const baseAnswer = buildBaseAnswer(row, CATEGORY);
  const answer: ImpactCo2Answer<ValuesCateringMeal> = {
    ...baseAnswer,
    values: {
      ...baseAnswer.values,
      mealType,
      mealCount,
    },
  };
  return answer;
}

function mapToMealType(row: ImportedRow): MealType {
  const tgsValue = row['Fairly Sub Category Description'];
  const result = validateValueInType<MealType>(tgsValue, MealTypeValues);
  if (!result) {
    throw new ImportMappingError('mealType', tgsValue, row);
  }
  return result;
}

function mapToMealCount(row: ImportedRow): number {
  const tgsValue = row['Quantity'];
  const result = parseInt(tgsValue, 10);
  if (isNaN(result)) {
    throw new ImportMappingError('mealCount', tgsValue, row);
  }
  return result;
}
